import { extendTailwindMerge } from "tailwind-merge";

type ClassValue = string | false | null | undefined;

const mergeClasses = extendTailwindMerge({
  extend: {
    theme: {
      text: ["label", "body-sm", "body", "title-sm", "title", "display"],
    },
  },
});

export function cn(...values: ClassValue[]) {
  return mergeClasses(values.filter(Boolean).join(" "));
}
